import React from "react";

const zones = [
  {
    id: "A",
    image: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e", // Forest
  },
  {
    id: "B",
    image: "https://images.unsplash.com/photo-1472396961693-142e6e269027", // Grassland
  },
  {
    id: "C",
    image: "/zone-c.jpg" // Wetland
  },
  {
    id: "D",
    image: "/zone-d.jpg" // Mountains
  }
];

export default function ZoneGrid({ selectedZone, onSelectZone }) {
  return (
    <div className="grid grid-cols-2 gap-4 w-1/2">
      {zones.map((zone) => (
        <div
          key={zone.id}
          onClick={() => onSelectZone(zone.id)}
          className={
            `h-62 bg-cover bg-center rounded-lg flex items-center justify-center text-white 
             font-bold shadow-md cursor-pointer transition 
             ${selectedZone === zone.id ? "ring-4 ring-blue-400" : "ring-2 ring-transparent"}`
          }
          style={{ backgroundImage: `url('${zone.image}')` }}
        >
          Zone {zone.id}
        </div>
      ))}
    </div>
  );
}